import { render, staticRenderFns } from "./TemplateAdd.vue?vue&type=template&id=57648385&scoped=true"
import script from "./TemplateAdd.vue?vue&type=script&lang=js"
export * from "./TemplateAdd.vue?vue&type=script&lang=js"
import style0 from "./TemplateAdd.vue?vue&type=style&index=0&id=57648385&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57648385",
  null
  
)

export default component.exports